import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './PartyAPI';
import {getColumns} from './PartyStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getPartyView} from './PartyView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deletePartyObj  ,setSelectedPartyId,setPartyPartyMgmtModal,setPartySubmittoapproveModal,setPartyAddPartyModal,setSelectedActionId , setShowEditForParty} from 'store/slice/PharmaSlice';

import PartyListTable from './components/PartyListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import PartyFilterCriteria from './PartyFilterCriteria';


import RuleIcon from '@mui/icons-material/Rule';
import AddTaskIcon from '@mui/icons-material/AddTask';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

import PartyMgmtActionModal from './action/partyMgmt/PartyMgmtActionModal';
import SubmittoapproveActionModal from './action/submittoapprove/SubmittoapproveActionModal';
import AddPartyActionModal from './action/AddParty/AddPartyActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function PartyList( {tableList, cardList, setShowEdit, setPartyId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, partyObj} = useSelector((state)=>state.pharmaslice.partyDashboard);
  const { partyList } = useSelector((state) => state.pharmaslice.partyDashboard);

  useEffect(() => {
  }, [partyList, partyObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedPartyId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deletePartyObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedPartyId(id));
    dispatch(setShowEditForParty(true));
  }
  
  const createParty=()=>{
    dispatch(setSelectedPartyId(-1));
    dispatch(setShowEditForParty(true));
  }


  const partyMgmtCallBack = (id) =>{
    dispatch(setSelectedPartyId(id));
    dispatch(setPartyPartyMgmtModal(true));
  }
  const submittoapproveCallBack = (id) =>{
    dispatch(setSelectedPartyId(id));
    dispatch(setPartySubmittoapproveModal(true));
  }
  const AddPartyCallBack = (id) =>{
    dispatch(setSelectedPartyId(id));
    dispatch(setPartyAddPartyModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const partyTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    partyList:partyList,
    cardList:getPartyView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:43, title:'Party Mgmt', callBackMethod:partyMgmtCallBack, icon:<RuleIcon/>, status:'UNDER APPROVAL', role:'PHARMA_OMS_MANAGER, PHARMA_OMS_MD, PHARMA_OMS_ADMIN'},
        {id:44, title:'Submit to Approve', callBackMethod:submittoapproveCallBack, icon:<AddTaskIcon/>, status:'DRAFT,REFERRED BACK', role:'PHARMA_OMS_MANAGER, PHARMA_OMS_SALES'},
        {id:121, title:'Add Party', callBackMethod:AddPartyCallBack, icon:<PersonAddAltIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:partyTransformation(tableList),
      partyList:partyList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:43, title:'Party Mgmt', callBackMethod:partyMgmtCallBack, icon:<RuleIcon/>, status:'UNDER APPROVAL', role:'PHARMA_OMS_MANAGER, PHARMA_OMS_MD, PHARMA_OMS_ADMIN'},
        {id:44, title:'Submit to Approve', callBackMethod:submittoapproveCallBack, icon:<AddTaskIcon/>, status:'DRAFT,REFERRED BACK', role:'PHARMA_OMS_MANAGER, PHARMA_OMS_SALES'},
        {id:121, title:'Add Party', callBackMethod:AddPartyCallBack, icon:<PersonAddAltIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={3}>
                        <Typography variant='h4' color="primary.darker">Party Information</Typography>
                      </Grid>
                      <Grid item lg={8}>
                      {showfilter ?  < PartyFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {/*view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            */}
                            <Grid item>
                              <Tooltip title="Add Party" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createParty()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < PartyListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<PartyMgmtActionModal/>
<SubmittoapproveActionModal/>
<AddPartyActionModal/>
    </>
);


}